import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "antd";
import { MAIN_MENU, isMenuItemActive } from "./mainMenuItems";

// Horizontal main menu, DashLite markup — active item gets the theme's
// 3px accent underline via .nk-menu-item.active (core/layouts/_menu-main.scss).
// Items with `children` render as a hover dropdown (e.g. Norms → Material /
// Manpower) with a caret so it's clearly a menu.
const MainMenu: FC = () => {
  const location = useLocation();

  return (
    <ul className="nk-menu nk-menu-main ui-s2">
      {MAIN_MENU.map((item) => {
        const active = isMenuItemActive(location.pathname, item);

        if (item.children && item.children.length) {
          return (
            <li
              key={item.key}
              className={`nk-menu-item has-sub${
                active ? " active current-page" : ""
              }`}
            >
              <Dropdown
                trigger={["hover"]}
                placement="bottomLeft"
                menu={{
                  items: item.children.map((child) => ({
                    key: child.key,
                    label: (
                      <Link to={child.link} className="nk-menu-link">
                        {child.text}
                      </Link>
                    ),
                  })),
                }}
              >
                <a
                  href="#toggle"
                  className="nk-menu-link nk-menu-toggle"
                  onClick={(e) => e.preventDefault()}
                >
                  <span className="nk-menu-text">{item.text}</span>
                </a>
              </Dropdown>
            </li>
          );
        }

        return (
          <li
            key={item.key}
            className={`nk-menu-item${active ? " active current-page" : ""}`}
          >
            <Link to={item.link} className="nk-menu-link">
              <span className="nk-menu-text">{item.text}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default MainMenu;
